import {
  ExternalLinkDTO,
  ExternalLinkOwnerType,
  useCreateExternalLink,
  useUpdateExternalLink,
} from "@/api/external-link";
import { LinkableType } from "@/components/LinksManagement";
import { zodResolver } from "@hookform/resolvers/zod";
import { ReactNode } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const schema = z.object({
  name: z.string().optional(),
  url: z.string().optional(),
  dateConsultation: z.string().optional(),
  notes: z.string().optional(),
});

const mapType = (type: LinkableType): ExternalLinkOwnerType =>
  type as ExternalLinkOwnerType;

const ExternalLinkDrawer = ({
  data,
  ownerId,
  type,
  open,
  onOpenChange,
  trigger,
}: {
  data?: ExternalLinkDTO;
  ownerId: string;
  type: LinkableType;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: ReactNode;
}) => {
  const ownerType = mapType(type);
  const { mutate: createExternalLink } = useCreateExternalLink(ownerType, ownerId);
  const { mutate: updateExternalLink } = useUpdateExternalLink(ownerType, ownerId);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      name: data?.name ?? "",
      url: data?.url ?? "",
      dateConsultation: data?.dateConsultation ?? "",
      notes: data?.notes ?? "",
    },
  });

  const onSubmit = (values: z.infer<typeof schema>) => {
    if (data?.id) {
      updateExternalLink({
        id: data.id,
        data: values,
      });
      return;
    }
    createExternalLink(values);
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={[
        { name: "name", type: "text", label: "Nom du lien", className: "w-full" } as any,
        { name: "url", type: "text", label: "URL", className: "w-full" } as any,
        {
          name: "dateConsultation",
          type: "text",
          label: "Date de consultation",
          className: "w-full",
        } as any,
        { name: "notes", type: "richtext", label: "Notes", className: "w-full" } as any,
      ]}
      recordId={data?.id}
      onSubmit={onSubmit}
      open={open}
      onOpenChange={onOpenChange}
      trigger={trigger}
    />
  );
};

export default ExternalLinkDrawer;
